module.exports = __webpack_public_path__ + "img/coming-soon.be369308.svg";